import React from 'react';
import { ExternalLinkListItem } from './ExternalLinkListItem';
import ILink from '../../../../types/ILink';

export type ExternalLinkDetailsViewProps = {
  externalLink: ILink;
};

export default function ExternalLinkDetailsView({ externalLink }: ExternalLinkDetailsViewProps) {
  return (
    <div className="external-link-details-view">
      <ExternalLinkListItem name={externalLink?.name} url={externalLink?.url} />
    </div>
  );
}
